<template>
	<div>
		<menu-item
			v-for="item in menu"
			:key="item.path.name"
			:item="item"
		></menu-item>
	</div>
</template>

<script>
import MenuItem from "./MenuItem";
import { mapGetters } from "vuex";

export default {
	components: {
		MenuItem
	},
	computed: {
		menu() {
			return this.$store.getters.navigation;
		}
	},
	methods: {
		close() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss" scoped>
.navbar-item {
	&-active {
		color: $navbar-item-active-color;
		border-bottom: 2px solid $navbar-item-active-color;
		&[href="/"] {
			color: $navbar-item-color;
			border-bottom: none;
		}
	}
}
</style>
